import React from 'react'
import { GlobalSearchContext } from 'modules/react/global-search/GlobalSearchContainer'
import GlobalSearchPagination from 'modules/react/global-search/GlobalSearchPagination'
import GlobalSearchResult from 'modules/react/global-search/GlobalSearchResult'
import classNames from 'classnames'

export default function GlobalSearchContent () {

  const { search, setDebouncedSearch, results, totalPosts, setContainerRef, loading, setLoading, errorImage } = React.useContext(GlobalSearchContext)

  const searchText = () => {
    let text = `resultater fundet`
    if (totalPosts === 1) {
      text = `resultat fundet`
    }
    return `${totalPosts} ${text}`
  }

  const handleOnChange = (e) => {
    setDebouncedSearch(e)
    setLoading(true)
  }

  const containerRef = React.useRef(null)

  React.useEffect(() => {
    setContainerRef(containerRef)
  }, [containerRef])

  return (
    <section className={classNames('global-search br-tl', {
      'global-search--loading': loading
    })} ref={containerRef}>
      <div className="global-search__inner page_container">
        <div className="global-search__title-container">
          <div className="global-search__tagline tagline">Søg</div>
          <h1 className="global-search__title">Hvad leder du efter?</h1>
        </div>
        <div className="global-search__content-wrap">
          <div className="global-search__results-header">
            <input type="text" className="search-input" defaultValue={search} placeholder="Søg.." onChange={handleOnChange} />
            <div className="tagline tagline--prim">{searchText()}</div>
          </div>
          <div className="global-search__results-subheader">
            <div className="tagline tagline--prim">{searchText()}</div>
          </div>
          <div className="global-search__results">
            {results.length > 0 ?
              results.map(result => <GlobalSearchResult key={result.id} {...result}/>) :
              (<div className="global-search__error-message"><img src={errorImage} alt="Error - no results" /></div>)
            }
          </div>
          <div className="global-search__results-footer">
            <GlobalSearchPagination/>
          </div>
        </div>
      </div>
    </section>
  )
}